// import { Button } from "antd";
// import { DeleteOutlined } from "@ant-design/icons";
import moment from "moment";

/**
 * createColumns
 * Complemento para mostrar las tablas tanto como en antd y modo responsive
 * @param {Function} showEditModal
 * @param {Function} showDeleteModal
 * @param {Number} page
 */
export function createColumns(
  page = 1,
  pageSize = 10,
  handleDelete,
  porSedeEnabled = false,
  porPeriodoEnabled = false
) {
  const columns = [
    {
      title: "N.º",
      key: "index",
      render: (value, item, index) => (page - 1) * pageSize + index + 1
    },
    {
      title: "Canal",
      dataIndex: "idcanal",
      key: "idcanal",
      sorter: (a, b) => a.idcanal - b.idcanal
    },
    {
      title: "Aula",
      dataIndex: "aula",
      key: "aula",
      sorter: (a, b) => a.aula.localeCompare(b.aula)
    },
    {
      title: "Código",
      dataIndex: "codigo",
      key: "codigo",
      sorter: (a, b) => a.codigo.localeCompare(b.codigo)
    },
    {
      title: "DNI",
      dataIndex: "nrodocumento",
      key: "nrodocumento",
      sorter: (a, b) => a.nrodocumento.localeCompare(b.nrodocumento)
    },
    {
      title: "Apellido",
      dataIndex: "apellido",
      key: "apellido",
      sorter: (a, b) => a.apellido.localeCompare(b.apellido)
    },
    {
      title: "Nombre",
      dataIndex: "nombre",
      key: "nombre",
      sorter: (a, b) => a.nombre.localeCompare(b.nombre)
    },
    {
      title: "Asistió",
      dataIndex: "asistio",
      key: "asistio",
      render: (asistio) => {
        if (!asistio) return <p></p>;
        return <p className="font-bold">SÍ</p>;
      },
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Hora",
      dataIndex: "horaasistio",
      key: "horaasistio",
      render: (horaasistio) => {
        if (!horaasistio) return <p></p>;
        return <p>{moment(horaasistio).format("hh:mm A")}</p>;
      },
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Asistencia",
      dataIndex: "contador",
      key: "contador",
      sorter: (a, b) => a.contador - b.contador
    }
    // {
    //   title: "Acciones",
    //   key: "action",
    //   render: (record) => <Button icon={<DeleteOutlined />} onClick={() => handleDelete(record)} />
    // }
  ];

  if (porSedeEnabled) {
    columns.splice(3, 0, {
      title: "Sede",
      dataIndex: "sede",
      key: "sede",
      sorter: (a, b) => (a.sede || "").localeCompare(b.sede || "")
    });
  }

  if (porPeriodoEnabled) {
    columns.splice(4, 0, {
      title: "Periodo",
      dataIndex: "periodo",
      key: "periodo",
      sorter: (a, b) => (a.periodo || "").localeCompare(b.periodo || "")
    });
  }

  return columns;
}
